import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'BaseDataService',
    controller: 'Region'
};

const methods = [
    'GetRegionInfos'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const RegionApi = ZJApi.defineNewApi('RegionApi', factory);

export default RegionApi;